import { useCallback } from 'react';

import { type BillingCyclePricing } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

type TrackSelectedPlanParams = {
  billingCycle: BillingCyclePricing['id'];
  planPrice: BillingCyclePricing['planPrice'];
};

export const useTrackSelectedPlan = () => {
  const { track } = useAnalyticsUtilities();

  const trackSelectedPlan = useCallback(
    (params: TrackSelectedPlanParams) => {
      track(`Selected plan in checkout`, params);
    },
    [track],
  );

  return { trackSelectedPlan };
};
